const mandatoryFields = ['email'];

export default mandatoryFields;
